import { WhatWeOffer } from "../../../WhatWeOffer/WhatWeOffer";

export const IndiaSec4 = ({ data, heading }) => {

    return (
        <WhatWeOffer data={data}
            heading={heading}
        // subHeading={"INDIA: WHERE EVERY MOMENT TELLS A STORY"}
        />
    );
};